import './index.scss';

export const FacilitacaoOtimizacao = () => {

    return (
        <div className='dados-empresa' style={{backgroundColor:"#F8F8F9"}}>
        <div>
            <div>
                <h1>
                    Facilitação e otimização das operações cambiais.
                </h1>
                <p>
                    Facilitação e otimização das operações cambiais Nossos produtos de crédito
                    trazem tranquilidade para o seu negócio, reduzindo riscos e ampliando as
                    possibilidades de atuação no mercado internacional, aumentando a rentabilidade,
                    fidelizando clientes, diversificando a carteira de produtos e permite que empresas
                    que atuam no comércio internacional, expandam sua atuação para além do mercado
                    doméstico.
                </p>
            </div>
            <div className='buttons-style'>
                <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
            </div>
        </div>
    </div>
    )
}

